import {
  APPOINTMENT_TYPE,
  NOTIFICATION_TYPES,
  PARTNER_APP_CALL_TO_ACTION,
  SUBDOMAIN_SHARE_QUERY_TYPES,
  FEATURE_FLAGS,
  PARTNER_APP_TYPES,
} from '@/lib/consts.js'
import { GBP_ENTRY_POINTS, GBP_ENTRY_SOURCE_KEY } from '@/components/promotion/google-business-profile/consts.js'
import {
  INSTAGRAM_BOOKINGS_ENTRY_SOURCE_KEY,
  INSTAGRAM_BOOKINGS_ENTRY_POINTS,
  ONLINE_BOOKING_ENTRY_SOURCES,
  ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY,
} from '@/components/settings/online-booking/consts.js'
import { SPLASH_SCREEN_ROUTING } from '@/views/business/settings/splash-screens/const.js'
import { useCore } from '@/composables/core'
import { ENTRANCE_PATH } from '@/lib/analytics/consts.js'
import { useEmitter } from '@/composables/emitter'
import { useExtole } from '@/composables/extole'
import { useFakeDoor } from '@/composables/fake-door'
import { useEppo } from '@/composables/eppo'
import { usePartnerApps } from '@/composables/partner-apps'

export function notificationAction ({ target_type, target_id, params }) {
  const { router } = useCore()

  return new Promise((resolve) => {
    const redirectToRoute = params => {
      router.push(params)
      resolve()
    }

    const openDeepLink = () => {
      if (!target_id) {
        return resolve()
      }

      const isInnerAppLink = target_id.indexOf('https://dl.booksy.com/') === 0
        || target_id.indexOf('https://go.booksy.com/') === 0

      if (isInnerAppLink) {
        window.location = target_id
      } else {
        window.open(target_id, '_blank')
      }

      resolve()
    }

    if (target_type === NOTIFICATION_TYPES.DEEPLINK) {
      openDeepLink()
    } /* CALENDAR */ else if (target_type === NOTIFICATION_TYPES.BOOKING) {
      if (target_id) {
        const { store } = useCore()
        store.dispatch('appointment/load', {
          id: target_id,
          type: APPOINTMENT_TYPE.SINGLE,
          edit: true,
        }).then(resolve)
      }
      resolve()
    } else if (target_type === NOTIFICATION_TYPES.AGENDA) {
      const { emit, EVENTS } = useEmitter()
      emit(EVENTS.CALENDAR_AGENDA_OPEN, {})
      resolve()
    } else if (target_type === NOTIFICATION_TYPES.FEEDBACK) {
      const { emit, EVENTS } = useEmitter()
      emit(EVENTS.CALENDAR_FEEDBACK_OPEN, {})
      resolve()
    } else if (target_type === NOTIFICATION_TYPES.CUSTOMERS) {
      redirectToRoute({ name: 'customers-main' })
    } else if (target_type === NOTIFICATION_TYPES.TRANSACTION) {
      redirectToRoute({
        name: 'settings.payments.transactions.details',
        params: {
          transactionId: target_id,
        },
      })
    } /* PROFILE */ else if (target_type === NOTIFICATION_TYPES.PROFILE) {
      redirectToRoute({ name: 'profile' })
    } else if (target_type === NOTIFICATION_TYPES.PROFILE_COMPLETENESS) {
      redirectToRoute({ name: 'completeness' })
    } else if (target_type === NOTIFICATION_TYPES.REVIEW) {
      redirectToRoute({
        name: 'reviews',
        params: {
          id: target_id,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.REVIEW_LIST) {
      redirectToRoute({
        name: 'reviews',
      })
    } else if (target_type === NOTIFICATION_TYPES.PORTFOLIO_PHOTO) {
      redirectToRoute({
        name: 'portfolio',
        params: {
          id: target_id,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.PORTFOLIO) {
      redirectToRoute({
        name: 'portfolio',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.REFERRAL) {
      const { isExtoleB2BReferralsEnabled, openReferralWindow } = useExtole()
      if (isExtoleB2BReferralsEnabled.value) {
        openReferralWindow().then(resolve)
      } else {
        redirectToRoute({
          name: 'profile',
          params: {
            openReferral: true,
          },
        })
      }
    } else if (target_type === NOTIFICATION_TYPES.REFERRAL_KYC) {
      redirectToRoute({
        name: 'settings.payments.your-account',
        query: {
          kyc: true,
          'going-from-referral': '1',
        },
      })
    } /* VOUCHERS */ else if (target_type === NOTIFICATION_TYPES.GIFT_CARDS) {
      redirectToRoute({
        name: 'gifts-and-bundle-services',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOKSY_WALLET) {
      redirectToRoute({
        name: 'booksy-wallet',
        query: {
          entrancePath: ENTRANCE_PATH.NOTIFICATION,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.SOLD_GIFT_CARDS) {
      redirectToRoute({
        name: 'gift-cards',
      })
    } /* REPORTS */ else if (target_type === NOTIFICATION_TYPES.PROFILE_STATISTICS) {
      redirectToRoute({
        name: 'stats-and-reports',
      })
    } /* PROMOTIONS */ else if (target_type === NOTIFICATION_TYPES.FLASH_SALE) {
      redirectToRoute({
        name: 'promotion.flash-sale',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOKSY_AWARDS) {
      redirectToRoute({
        name: 'booksy-awards',
      })
    } else if (target_type === NOTIFICATION_TYPES.MARKETING_FLASH_SALE) {
      redirectToRoute({
        name: 'promotion.flash-sale',
      })
    } else if (target_type === NOTIFICATION_TYPES.HAPPY_HOURS) {
      redirectToRoute({
        name: 'promotion.happy-hours',
      })
    } else if (target_type === NOTIFICATION_TYPES.MARKETING_HAPPY_HOURS) {
      redirectToRoute({
        name: 'promotion.happy-hours',
      })
    } else if (target_type === NOTIFICATION_TYPES.LAST_MINUTE) {
      redirectToRoute({
        name: 'promotion.last-minute',
      })
    } else if (target_type === NOTIFICATION_TYPES.MARKETING_LAST_MINUTE) {
      redirectToRoute({
        name: 'promotion.last-minute',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOST_GENERIC) {
      redirectToRoute({
        name: 'boost',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOST_DASHBOARD) {
      redirectToRoute({
        name: 'promotion',
        params: {
          boostTileClicked: true,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOST_VISIBILITY) {
      redirectToRoute({
        name: 'boost',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOST_PROFILE) {
      redirectToRoute({
        name: 'promotion',
      })
    } else if (target_type === NOTIFICATION_TYPES.INVITE_CUSTOMERS) {
      redirectToRoute({
        name: 'promotion--invite',
      })
    } else if (target_type === NOTIFICATION_TYPES.DIGITAL_FLYER) {
      redirectToRoute({
        name: 'promotion.social-media',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.SHARE) {
      redirectToRoute({
        name: 'promotion.social-media',
      })
    } else if (target_type === NOTIFICATION_TYPES.BLAST_DASHBOARD) {
      redirectToRoute({
        name: 'message-clients.dashboard',
      })
    } else if (target_type === NOTIFICATION_TYPES.BLAST_TEMPLATE) {
      redirectToRoute({
        name: 'message-clients.preview',
        params: {
          id: target_id,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOST_BAN) {
      redirectToRoute({
        name: 'boost',
      })
    } /* SETTINGS */ else if (target_type === NOTIFICATION_TYPES.SERVICES) {
      redirectToRoute({
        name: 'services-services',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.NO_SHOW_PROTECTION) {
      redirectToRoute({
        name: 'settings.payments-no-show-protection',
        params: { target_type: 1 },
        query: { entrancePath: ENTRANCE_PATH.NOTIFICATION },
      })
    } else if (target_type === NOTIFICATION_TYPES.ENABLE_NO_SHOW_PROTECTION) {
      redirectToRoute({
        name: 'settings.payments-no-show-protection',
        params: { target_type: 1 },
        query: { entrancePath: ENTRANCE_PATH.NOTIFICATION },
      })
    } else if (target_type === NOTIFICATION_TYPES.PROFILE_PHOTOS) {
      redirectToRoute({
        name: 'details-photos',
      })
    } else if (target_type === NOTIFICATION_TYPES.BUSINESS_SAFETY_RULES) {
      redirectToRoute({
        name: 'settings.health-safety-rules',
      })
    } else if (target_type === NOTIFICATION_TYPES.KYC_NOTIFICATION) {
      redirectToRoute({
        name: 'settings.payments.your-account',
        query: {
          kyc: true,
        },
        params: {
          turn_on_pba: false,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.PREPAYMENT_POPUP) {
      redirectToRoute({
        name: 'settings.payments.payment-types.mobile-payments-success',
      })
    } else if (target_type === NOTIFICATION_TYPES.STRIPE_DASHBOARD) {
      redirectToRoute({
        name: 'settings.payments.payment-types.booksy-card-reader',
        params: { target_type: 1 },
      })
    } else if ([NOTIFICATION_TYPES.KYC_DASHBOARD, NOTIFICATION_TYPES.KYC_DASHBOARD_STRIPE].includes(target_type)) {
      redirectToRoute({
        name: 'settings.payments.your-account',
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOKING_TOOLS) {
      redirectToRoute({
        name: 'settings-online-booking',
        query: {
          [ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY]: ONLINE_BOOKING_ENTRY_SOURCES.TARGET_TYPE,
        },
      })
    } /* PARTNER APP */ else if (target_type === NOTIFICATION_TYPES.PARTNER_TYPE_ACTION) {
      redirectToRoute({
        name: 'partner-app',
        params: {
          partnerType: target_id,
          notificationParams: {
            ...params,
          },
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.PARTNER_TYPE_SETUP) {
      redirectToRoute({
        name: 'partner-app',
        params: {
          partnerType: target_id,
          callToActionName: PARTNER_APP_CALL_TO_ACTION.SETTINGS,
          notificationParams: {
            ...params,
          },
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.PARTNER_TYPE_DASHBOARD) {
      redirectToRoute({
        name: 'partner-app',
        params: {
          partnerType: target_id,
          callToActionName: PARTNER_APP_CALL_TO_ACTION.SIDEBAR,
          notificationParams: {
            ...params,
          },
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.CALENDAR_IMPORTER) {
      redirectToRoute({
        name: 'calendar-settings',
        params: {
          scrollToImportSettings: true,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.SUBDOMAIN_SHARE) {
      redirectToRoute({
        name: 'profile',
        query: {
          'subdomain_share': SUBDOMAIN_SHARE_QUERY_TYPES.TARGET_TYPE,
          ...params?.query,
        },
        params: {
          ...params?.params,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.FAKE_DOOR) {
      useFakeDoor().open()
    } else if (target_type === NOTIFICATION_TYPES.IMPORT_AND_INVITE) {
      redirectToRoute({
        name: 'promotion--invite',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.COVER_PHOTO) {
      redirectToRoute({
        name: 'details-cover-image',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.STORE) {
      redirectToRoute({
        name: 'inventory.ecommerce',
        query: {
          utm_source: 'booksy',
          utm_medium: 'banner',
          utm_campaign: 'calendar_embedded_banner',
          ...params?.query,
        },
        params: {
          ...params?.params,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.GOOGLE_BUSINESS_PROFILE) {
      const isGoogleBusinessProfileEnabled = useEppo().ff(FEATURE_FLAGS.Feature_GoogleBusinessProfile)
      const { store } = useCore()
      const isOwner = store.getters['identity/isOwner']
      const isTablet = store.getters['app/isTablet']
      const shouldRedirectToGbp = isOwner && isGoogleBusinessProfileEnabled && !isTablet
      redirectToRoute({
        name: shouldRedirectToGbp
          ? 'promotion.google-business-profile'
          : 'calendar',
        query: {
          ...(shouldRedirectToGbp && { [GBP_ENTRY_SOURCE_KEY]: GBP_ENTRY_POINTS.IN_APP_NOTIFICATION }),
          ...params?.query,
        },
        params: {
          ...params?.params,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.BUY_BOOKSY_MED) {
      const { partnerAppAction } = usePartnerApps()
      partnerAppAction(
        PARTNER_APP_TYPES.PHYSIOREGISTRATION,
        PARTNER_APP_CALL_TO_ACTION.SETTINGS,
        null,
        true
      )
    } else if (target_type === NOTIFICATION_TYPES.LOYALTY_PROGRAM) {
      redirectToRoute({
        name: 'settings.loyalty-program',
      })
    } else if (target_type === NOTIFICATION_TYPES.ONLINE_BOOKING_INSTAGRAM) {
      redirectToRoute({
        name: 'settings-online-booking',
        query: {
          ...params?.query,
          [INSTAGRAM_BOOKINGS_ENTRY_SOURCE_KEY]: INSTAGRAM_BOOKINGS_ENTRY_POINTS.IN_APP_NOTIFICATION,
          open_instagram_modal: 'true',
        },
        params: {
          ...params?.params,
        },
      })
    } else if (target_type === NOTIFICATION_TYPES.SUBSCRIPTIONS) {
      redirectToRoute({
        name: 'settings.subscription.your-subscription',
        ...params,
      })
    } else if (target_type === NOTIFICATION_TYPES.BOOKSY_PAY_ACTIVATION) {
      redirectToRoute({
        ...SPLASH_SCREEN_ROUTING.ENABLE_FEATURE.BOOKSY_PAY_ACTIVATION,
        query: {
          back_to: 'calendar',
          entrancePath: ENTRANCE_PATH.ITERABLE_BANNER,
        },
      })
    }
  })
}
